import React from "react"
import {Formik} from "formik"
import * as Yup from "yup"
import FullNameInput from "../../../FullName/FullName"
import DocumentTypeHeader from "./DocumentTypeHeader"
import {ApplicationDocumentType} from "../../../../resources/application"
import {SelfieVerificationDocumentFormValues} from "./types"
import {fullNameValidation} from "./validationSchemas"

interface SelfieVerificationDocumentFormProps {
	documentType: ApplicationDocumentType
	initialValues: SelfieVerificationDocumentFormValues
	onSubmit: (values: SelfieVerificationDocumentFormValues) => void
	formId: string
}

const validationSchema = Yup.object().shape({
	fullName: fullNameValidation,
})

export const SelfieVerificationDocumentForm = ({
	documentType,
	initialValues,
	onSubmit,
	formId,
}: SelfieVerificationDocumentFormProps) => {
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
			{({values, handleChange, handleBlur, handleSubmit}) => (
				<form onSubmit={handleSubmit} id={formId} className="edit-document-form">
					<div className="key-value-card-container-key">Type</div>
					<DocumentTypeHeader documentType={documentType} />

					<div className="key-value-card-container-key">Name</div>
					<div className="form-row two">
						<FullNameInput fullName={values.fullName} handleChange={handleChange} handleBlur={handleBlur} />
					</div>
				</form>
			)}
		</Formik>
	)
}
